import { render } from "./Publisher.vue?vue&type=template&id=5aadafe0&scoped=true"
import script from "./Publisher.vue?vue&type=script&lang=js"
export * from "./Publisher.vue?vue&type=script&lang=js"

import "./Publisher.vue?vue&type=style&index=0&id=5aadafe0&scoped=true&lang=css"

import exportComponent from "/root/tools-store-ranking-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aadafe0"]])

export default __exports__